export default "__VITE_ASSET__Dmcu0F5Q__"